import { defineMessages } from 'react-intl';

export default defineMessages({
  registrationTitle: {
    id: 'containers.popups.registration.title',
    defaultMessage: 'Registration',
  },
  loginTitle: {
    id: 'containers.popups.login.title',
    defaultMessage: 'Login',
  },
  forgotTitle: {
    id: 'containers.popups.forgot.title',
    defaultMessage: 'Forgot password',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Popups/messages.js